const collateralSubcategoryLabels = {
  flat: 'Bytom',
  house: 'Domom',
  apartman: 'Apartmánom',
  office: 'Kanceláriou',
  commercialSpace: 'Obchodným priestorom',
  polyfunction: 'Polyfunkciou',
  buildingLands: 'Pozemkom',
  meadow: 'Lúkou a poľom',
  garden: 'Záhradou',
  otherLand: 'Iným pozemkom',
  hotel: 'Hotelom',
  pension: 'Penziónom',
  cottage: 'Chatou',
  accommodation: 'Ubytovaním',
  gasStation: 'Benzínovou pumpou',
  logistics: 'Logistikou',
  manufacturingArea: 'Výrobným areálom',
  warehouse: 'Skladom',
  garage: 'Garážou',
  realEstate: 'Nehnuteľnosťou',
  other: 'Iným',
}

type CollateralSubcategoryLabels = typeof collateralSubcategoryLabels

type CollateralSubcategoryKey = keyof CollateralSubcategoryLabels

export function getProjectCollateralSubcategoryLabel(
  key: CollateralSubcategoryKey
) {
  return collateralSubcategoryLabels[key]
}
